import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = ({ role, nama, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path) => location.pathname === path ? 'active' : '';

  // Penjagaan nilai nama dinamis
  const namaUser = nama && nama.trim() !== "" ? nama : 'Admin / Staff';

  // Format tampilan label role agar lebih rapi di UI
  const formatRoleLabel = (userRole) => {
    switch (userRole) {
      case 'admin': return 'Administrator';
      case 'wakasek': return 'Wakil Kepala Sekolah';
      case 'kepsek': return 'Kepala Sekolah';
      case 'piket': return 'Guru Piket';
      case 'guru': return 'Guru Pengajar';
      case 'ortu': return 'Orang Tua';
      default: return userRole || 'User';
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h3>SMAN 10 Fajar Harapan</h3>
        <span style={{ fontSize: '12px', opacity: 0.7, letterSpacing: '1px' }}>SYSTEM V2.0</span>
      </div>

      {/* --- BOX PROFIL USER AKTIF --- */}
      <div style={{ padding: '15px 20px', background: 'rgba(255,255,255,0.05)', borderBottom: '1px solid rgba(255,255,255,0.1)', marginBottom: '15px' }}>
        <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={namaUser}>
          👤 {namaUser}
        </div>
        <div style={{ fontSize: '11px', color: '#38bdf8', textTransform: 'uppercase', fontWeight: 'bold', marginTop: '3px', letterSpacing: '0.5px' }}>
          🔑 Status: {formatRoleLabel(role)}
        </div>
      </div>

      <div className="menu">
        <p className="menu-label">Menu Utama</p>
        <button className={isActive('/')} onClick={() => navigate('/')}>🏠 Dashboard</button>
        
        {/* Input Absen Siswa (Khusus Guru, Piket, Wakasek, Admin) */}
        {(role === 'admin' || role === 'guru' || role === 'piket' || role === 'wakasek') && (
            <>
              <button className={isActive('/absen')} onClick={() => navigate('/absen')}>✅ Input Absen Kelas</button>
              <button className={isActive('/absen-sholat')} onClick={() => navigate('/absen-sholat')}>🕌 Absen Sholat</button>
              <button className={isActive('/absen-pengayaan')} onClick={() => navigate('/absen-pengayaan')}>📖 Absen Pengayaan</button>
            </>
        )}

        {/* Buku Saku / Poin Pelanggaran */}
        {(role === 'admin' || role === 'guru' || role === 'piket' || role === 'kepsek' || role === 'wakasek') && (
            <button className={isActive('/poin')} onClick={() => navigate('/poin')}>⚠️ Buku Saku (Poin)</button>
        )}

        {/* Monitoring KBM & Absen Guru Piket (Admin, Piket, Kepsek, Wakasek) */}
        {(role === 'admin' || role === 'piket' || role === 'kepsek' || role === 'wakasek') && (
            <>
                <button className={isActive('/monitoring')} onClick={() => navigate('/monitoring')}>📡 Monitoring KBM</button>
                <button className={isActive('/absen-guru')} onClick={() => navigate('/absen-guru')}>📝 Absen Guru Piket</button>
            </>
        )}

        {/* Database Sekolah (KHUSUS ADMIN) */}
        {role === 'admin' && (
          <>
            <p className="menu-label">Database Sekolah</p>
            <button className={isActive('/siswa')} onClick={() => navigate('/siswa')}>🎓 Data Siswa</button>
            <button className={isActive('/cetak-kartu')} onClick={() => navigate('/cetak-kartu')}>🪪 Cetak Kartu</button>
            <button className={isActive('/guru')} onClick={() => navigate('/guru')}>👨‍🏫 Data Guru</button>
            <button className={isActive('/kelas')} onClick={() => navigate('/kelas')}>🏫 Data Kelas</button>
            <button className={isActive('/mapel')} onClick={() => navigate('/mapel')}>📚 Data Mapel</button>
            <button className={isActive('/jadwal')} onClick={() => navigate('/jadwal')}>📅 Atur Jadwal</button>
            <button className={isActive('/asrama-pengayaan')} onClick={() => navigate('/asrama-pengayaan')}>🏠 Asrama & Pengayaan</button>
            <button className={isActive('/kenaikan-kelas')} onClick={() => navigate('/kenaikan-kelas')}>📈 Kenaikan Kelas</button>
          </>
        )}

        {/* Laporan & Rekapitulasi */}
        <p className="menu-label">Laporan & Rekap</p>
        <button className={isActive('/rekap-harian')} onClick={() => navigate('/rekap-harian')}>📊 Laporan Harian Siswa</button>
        <button className={isActive('/rekap-bulanan')} onClick={() => navigate('/rekap-bulanan')}>📅 Laporan Bulanan Siswa</button>
        <button className={isActive('/rekap-asrama-pengayaan')} onClick={() => navigate('/rekap-asrama-pengayaan')}>🕌 Rekap Asrama & Pengayaan</button>
        
        {/* Laporan Absen Guru (Admin, Kepsek, & Wakasek) */}
        {(role === 'admin' || role === 'kepsek' || role === 'wakasek') && (
            <button className={isActive('/rekap-guru')} onClick={() => navigate('/rekap-guru')}>👨‍💼 Laporan Absen Guru</button>
        )}

        <p className="menu-label">Lainnya</p>
        <button className={isActive('/jurnal')} onClick={() => navigate('/jurnal')}>📖 Jurnal Piket</button>
        
        {/* Manajemen User & Settings (KHUSUS ADMIN) */}
        {role === 'admin' && (
            <>
                <button className={isActive('/users')} onClick={() => navigate('/users')}>👥 Manajemen User</button>
                <button className={isActive('/settings')} onClick={() => navigate('/settings')}>⚙️ Pengaturan Sekolah</button>
            </>
        )}
        
        <button className="btn-logout" onClick={onLogout} style={{ marginTop: '20px' }}>🚪 Logout</button>
      </div>
    </div>
  );
};

export default Sidebar;